import React, { useState } from "react"

import Modal from "../ui/Modal"
import Login from "../auth/Login"
import { useAuthState } from "../../contexts/authContext"
import { useSiteConfig } from "../../hooks/useSiteConfig"
import { GatsbyImage } from "gatsby-plugin-image"
import { Typography } from "@mui/material"
import { Box } from "@mui/system"
import theme from "../../material-ui/theme"
import styled from "styled-components"
import ProOrgDetails from "./ProOrgDetails"

const CoverImage = styled(props => <GatsbyImage {...props} alt="" />)`
  object-fit: cover;
  bottom: 0;
  right: 0;
  top: 0;
  left: 0;
  object-position: 50% 50%;
  position: absolute !important;
  overflow: hidden;
`

interface Props {
  modalOpen: boolean
  setModalOpen: (open: boolean) => void
  onComplete?: () => void
}

const ProSignup = ({ modalOpen, setModalOpen, onComplete }: Props) => {
  const authState = useAuthState()

  const [loginMode, setLoginMode] = useState(false)
  const siteConfig = useSiteConfig()
  const { email } = authState
  return (
    <>
      <Modal setIsOpen={setModalOpen} isOpen={modalOpen} padding="0">
        <Box sx={{ display: "block", position: "relative" }}>
          <Box
            sx={{
              width: "300px",
              height: "100%",
              overflow: "hidden",
              position: "absolute",
              [theme.breakpoints.down("md")]: {
                height: "150px",
                width: "100%",
              },
            }}
          >
            <CoverImage
              image={
                siteConfig?.proSignupImg?.imageFile?.childImageSharp
                  ?.gatsbyImageData
              }
              alt={siteConfig?.proSignupImg?.alternativeText}
              objectFit="cover"
              objectPosition="50% 50%"
            />
          </Box>

          <Box
            sx={{
              marginLeft: "320px",
              marginRight: "20px",
              width: "600px",
              [theme.breakpoints.down("md")]: {
                marginLeft: "20px",
                marginTop: "150px",
                width: "auto",
              },
            }}
          >
            {!email && (
              <Box
                sx={{
                  padding: "2rem 0",
                }}
              >
                <Typography
                  className="gradientText"
                  component="h2"
                  variant="h5"
                  data-testid={"form-title"}
                >
                  {!loginMode &&
                    (siteConfig.proSignupAccountTitle ??
                      "Create Your Professional Account & Checkout")}
                  {loginMode &&
                    (siteConfig.proSignupLoginTitle ??
                      "Login to Your Account & Checkout")}
                </Typography>
                <p>
                  {siteConfig.proSignupAccountMsg ??
                    "With a Professional account, you can get Sens.ai Professional products and services for your clinic or practice."}
                </p>
                <Login
                  startLoginMode={loginMode}
                  email={""}
                  alreadyHaveAccountTxt="I already have a Sens.ai Account"
                  showHeader={false}
                  setLoginMode={setLoginMode}
                  loginMode={loginMode}
                  noRedirect={true}
                />
              </Box>
            )}
            {email && (
              <Box sx={{ padding: "2rem 1rem" }}>
                <Typography
                  className="gradientText"
                  component="h2"
                  variant="h5"
                  data-testid={"form-title"}
                >
                  {siteConfig.proSignupOrgTitle ??
                    "Setup Your Professional Account"}
                </Typography>
                <p>
                  {siteConfig.proSignupOrgMsg ??
                    "With a Professional account, you can get Sens.ai Professional products and services for your clinic or practice."}
                </p>
                <ProOrgDetails onComplete={onComplete} />
              </Box>
            )}
          </Box>
        </Box>
      </Modal>
    </>
  )
}

export default ProSignup
